<template>
  <div>
    <a-row type="flex" justify="end">
      <!-- <a-col>
        <img :src="canvas" alt="" width="160px" style="border:1px solid " />
      </a-col>-->
      <a-col>
        <a-button
          type="primary"
          @click="editRole()"
          v-if="isGranted('system_setting.role_manager.btn_global_create')"
        >
          <a-icon type="plus"></a-icon>新建角色
        </a-button>
      </a-col>
    </a-row>

    <a-row :gutter="80" align="top" style="padding-top:20px;">
      <a-col>
        <a-table
          :pagination="false"
          :dataSource="tableData"
          :columns="columns"
          rowKey="id"
          :loading="loading"
        >
          <template slot="status" slot-scope="status, record">
            <a-switch :checked="status == 1" @click="checkStatus(record)">{{ record.name }}</a-switch>
          </template>
          <template slot="action" slot-scope="text, record">
            <a-row type="flex" :gutter="10" justify="start">
              <a-col>
                <a
                  @click.prevent="editRole(record)"
                  v-if="isGranted('system_setting.role_manager.btn_list_edit')"
                >编辑</a>
              </a-col>
              <!-- <a-col>
                <a
                  @click.prevent="$refs.authModal.show(record)"
                  v-if="
                    isGranted(
                      'system_setting.role_manager.btn_list_permission_set'
                    )
                  "
                >权限设置</a>
              </a-col> -->
              <a-col>
                <a
                  @click.prevent="delRole(record)"
                  v-if="
                    isGranted('system_setting.role_manager.btn_list_delete')
                  "
                >删除</a>
              </a-col>
            </a-row>
          </template>
        </a-table>
      </a-col>
    </a-row>
    <operate-role-modal ref="operateModal" @ok="getData()"></operate-role-modal>
    <auth-role-modal ref="authModal"></auth-role-modal>
  </div>
</template>

<script>
import OperateRoleModal from "./operate-role-modal";
import AuthRoleModal from "./auth-role-modal";
import Api from "@/api";
import { mapGetters } from "vuex";
import baseComponentVue from "@/components/base-component.vue";
export default {
  name: "Role",
  extends: baseComponentVue,
  data() {
    return {
      loading: false,
      tableData: [],
      columns: [],
      canvas: ""
    };
  },
  components: { OperateRoleModal, AuthRoleModal },
  computed: {
    ...mapGetters(["isGranted", "isAnyGranted"])
  },
  created() {
    this.setColumns();
    this.getData();
  },
  methods: {
    setColumns() {
      let columns = [
        { title: "名称", dataIndex: "name" },
        { title: "角色说明", dataIndex: "description" },
        { title: "编辑时间", dataIndex: "updated_at" },
        {
          title: "状态",
          dataIndex: "status",
          scopedSlots: { customRender: "status" }
        }
      ];
      if (
        this.isAnyGranted([
          "system_setting.role_manager.btn_list_edit",
          "system_setting.role_manager.btn_list_permission_set",
          "system_setting.role_manager.btn_list_delete"
        ])
      ) {
        columns.push({
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" }
        });
      }
      this.columns = columns;
    },
    async getData() {
      this.loading = true;
      let response = await Api.system.getRoleList();
      this.tableData = response.roles;
      this.loading = false;
    },
    async checkStatus(record) {
      try {
        await Api.system.changeRoleStatus({
          id: record.id,
          status: record.status == "1" ? "2" : "1"
        });
        record.status = record.status == "1" ? "2" : "1";
      } catch (e) {}
    },
    editRole(record) {
      let { operateModal } = this.$refs;
      operateModal.show(record);
    },
    delRole(record) {
      const h = this.$createElement;
      this.$confirm({
        title: "温馨提示",
        content: h("div", { style: { paddingTop: "20px" } }, [
          h("p", "确定要删除该数据"),
          h("p", "删除后系统将不再显示该数据信息")
        ]),
        onOk: () => {
          return new Promise(async (resolve, reject) => {
            try {
              await Api.system.deleteRole({ id: record.id });
              this.getData();
            } catch (e) {}
            resolve();
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
